<template>
  <div class="video" style="position: relative">
    <div
      class="video-warp"
      v-if="videoFile.length>0"
      ref="video"
      id="video-warp"
      @click="showControl"
      :style="vcIsFull?fullCss:{'height':'6rem'}"
    >
      <!-- [vcIsFull?{'transform': 'rotate(90deg) translate(' + (Vheight-Vwidth)/2 + 'px,'+ (Vheight-Vwidth)/2+'px)','width': Vwidth + 'px','height': Vheight + 'px','transform-origin':'center center','-webkit-transform-origin': 'center center'}:{}] -->
      <video
        id="video"
        poster
        width="100%"
        height="100%"
        :src="url"
        autoplay
        x5-playsinline="true"
        playsinline="true"
        webkit-playsinline="true"
        preload="auto"
        x-webkit-airplay="allow"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        @canplay="canplay"
        @ended="ended"
        @loadeddata="loadeddata"
        @loadstart="loadstart"
        @waiting="waiting"
        v-tap="vuetouch"
        v-swipeleft="{fn:vuetouch,name:'左滑'}"
        v-swiperight="{fn:vuetouch,name:'右滑'}"
        v-swipeup="{fn:vuetouch,name:'上滑'}"
        v-swipedown="{fn:vuetouch,name:'下滑'}"
        x5-video-orientation="landscape|portrait"
      >
        <!-- webkit-playsinline="true"
        playsinline="true"-->
        <source :src="url" type="video/ogg" />当前浏览器不支持 video直接播放，点击这里下载视频：
        <!-- <a href="myvideo.webm">下载视频</a> -->
      </video>

      <!-- 播放按钮 -->
      <div
        style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;width: 100%;width:60px;height:60px;margin: auto;z-index:201111"
        @click="play"
        v-if="isPlay&&showPlayBtn"
      >
        <img src="../assets/14@2x.png" style="width: 60px;height:60px;" alt />
      </div>

      <!-- 视频加载动画 -->
      <div
        style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;width: 100%;margin: auto;"
        v-if="videoLoading"
      >
        <img width="100%" height="100%" src="../assets/video-loading.gif" alt />
      </div>
      <!-- 视频获取失败 -->
      <div
        class="videoError"
        style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;width: 100%; height: 50px;margin: auto;"
        v-if="disabled&&showTip"
      >
        <p style="text-align:center;color:#fff;line-height:50px;font-size: 14px;">视频获取错误,请联系管理员。</p>
      </div>
      <!-- 清晰度切换提示 -->
      <div
        style="position: absolute;top: 10px;bottom: 0;left: 0;right: 0;width: 100%; height: 50px;opacity: 0.8"
        v-if="type_name_show"
      >
        <p style="text-align:center;color:#fff;line-height:50px;font-size: 14px;">
          正在切换至
          <font style="color:#f40;font-size: 16px;">{{type_name}}</font> ,请稍后...
        </p>
      </div>
      <!-- 跳转到下一集提示 -->
      <div
        style="position: absolute;top: 10px;bottom: 0;left: 0;right: 0;width: 100%; height: 50px;opacity: 0.8"
        v-if="num_index_show"
      >
        <p style="text-align:center;color:#fff;line-height:50px;font-size: 14px;">
          正在跳转至
          <font style="color:#f40;font-size: 16px;">第{{num_index+1}} 集</font> ,请稍后...
        </p>
      </div>
      <!-- 视频标题显示 -->
      <div class="control_top" v-if="vcIsFull" style="height: 30px;font-size: 16px;">
        <img
          src="../assets/videoBack.png"
          class="backVideoIcon"
          style="width: 9px;height: 16px;"
          alt
          @click="backVideo"
        />
        <span style="color:#fff;font-size:14px;" @click="backVideo">{{videoTitle}}</span>
      </div>
      <!-- 控制条显示 -->
      <div class="controls" id="controls" style="height: 40px;font-size: 16px;" v-if="!vcIsFull||!NotPC||VWidth>VHeight">
        <div>
          <img id="play" src="../assets/21@2x.png" alt="播放" @click="play" v-if="isPlay" />
          <img id="pause" src="../assets/暂停@3x.png" alt="暂停" @click="pause" v-if="!isPlay" />
        </div>
        <!-- 时长 -->
        <div class="video-timer">
          <span id="currentTime">{{vcCurrentTime}}</span>
          <span>/</span>
          <span id="duration">{{vcTotalTime}}</span>
        </div>
        <!-- 进度条 -->
        <div class="progress">
          <slider
            v-model="percent"
            bar-height="4px"
            @change="onChange"
            :disabled="disabled"
          />
        </div>

        <!-- <i id="sound" class="sound"></i>
            <span id="muteSound" class="sound" @click="muteAction">{{isSound? '音量' : '静音'}}</span>
            <div class="video-sound" @click="enableSoundDrag">
                <div class="soundBar"></div>
        </div>-->
        <!-- <i id="screen"></i> -->
        <div class="articulate" v-if="vcIsFull">
          <span @click="ShowArticulationType">清晰度</span>
        </div>
        <div class="Anthology" v-if="vcIsFull&&showNum">
          <span @click="selectAnthology">选集</span>
        </div>
        <img id="fullScreen" src="../assets/23@2x.png" @click="fullScreen" alt="全屏" />
        <span @click="fullScreen"></span>
        <!-- <span id="playSpeed">*3</span> -->
      </div>
      <van-popup
        v-model="isShowAnthologyNum"
        style="position: absolute!important;width:100%;height:100%;background-color:transparent;"
        position="right"
        :overlay="false"
      >
        <div @click.self="showPopup" style="width:100%;height:100%;background-color:transparent;">
          <div
            class="AnthologyNum"
            style="width: 159px;font-size: 16px;padding-top: 20px;padding-bottom: 50px;"
          >
            <div style="height: 100%;overflow:auto">
              <div style="height: 100%;">
                <div
                  v-for="(item, index) in numList"
                  :class="{selectNum: index == num_index}"
                  :key="index"
                  style="width: 124px;height:38px;line-height: 38px;"
                  @click.self="selectNum_active(index)"
                >{{item}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <van-popup
        v-model="isShowArticulationType"
        style="position: absolute!important;width:100%;height:100%;background-color:transparent;"
        position="right"
        :overlay="false"
      >
        <div @click.self="showPopup" style="width:100%;height:100%;background-color:transparent;">
          <div
            class="articulationType"
            style="width: 159px;font-size: 16px;padding-top: 20px;padding-bottom: 50px;"
          >
            <div
              v-for="(item,index) in DefinitionList"
              :class="{selectType: index == type_index}"
              :key="index"
              style="width: 124px;height:38px;line-height: 38px;"
              @click.self="selectDefinition(item,index)"
            >{{item}}</div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="noVideo" v-if="videoFile.length==0">
      <p>暂无视频内容</p>
    </div>
    <div class="_controls" style="width: 40px;font-size: 16px;" v-if="vcIsFull&&NotPC&&VWidth<VHeight">
      <div class="play-icon">
          <img id="play" src="../assets/21@2x.png" alt="播放" @click="play" v-if="isPlay" />
          <img id="pause" src="../assets/暂停@3x.png" alt="暂停" @click="pause" v-if="!isPlay" />
        </div>
        <!-- 时长 -->
        <div class="_video-timer">
          <span id="_currentTime">{{vcCurrentTime}}</span>
          <span>/</span>
          <span id="_duration">{{vcTotalTime}}</span>
        </div>
        <!-- 进度条 -->
        <div class="_progress">
          <div :style="{ height: '100%', width: '4px'}">
            <slider v-model="percent" vertical="true" :disabled="disabled" @change="onChange"/>
          </div>
        </div>
        <div class="_articulate">
          <span @click="ShowArticulationType">清晰度</span>
        </div>
        <div class="_Anthology" v-if="showNum">
          <span @click="selectAnthology">选集</span>
        </div>
        <img id="fullScreen" src="../assets/23@2x.png" @click="fullScreen" alt="全屏" />
        <span @click="fullScreen"></span>
    </div>
  </div>
</template>

<script>
import { ChangeVideoArticulation } from "../service";
import { IsPC } from "../utils/index";
import "../utils/touch.js";
import { Slider } from "vant";
export default {
  name: "Video",
  props: ["videoFile", "poster"],
  components: {
    slider: Slider
  },
  data() {
    return {
      url: [],
      video: "",
      videoTitle: "", // 视频title
      timerListener: "", // 定时器
      percent: 0, // 进度条
      progress: "", // 进度条容器
      disabled: false, // 是否可拖拽
      showTip: false, //是否显示视频错误提示语
      warp: "",
      isPlay: true, // 是否播放
      isShowControl: true, // 是否展示控制条
      isShowArticulationType: false, // 是否展示清晰度变换
      isShowAnthologyNum: false, // 是否显示集数
      vcCurrentTime: "00:00", //当前进度
      vcTotalTime: "00:00", //总时长
      vcIsPlay: false, //video是否播放
      timrBar: "", //video进度
      sound: "", // 音量容器
      isSound: true, // 是否静音
      vcIsFull: false, //是否全屏
      Vwidth: "",
      Vheight: "",
      videoLoading: true, // 加载视频中
      fullCss: {}, // 全屏样式
      num_index: 0, // 第几集
      numList: [], // 集数列表
      num_index_show: false, // 跳转到下一集
      DefinitionList: [], // 清晰度列表
      type_index: 0,
      type_name: "", // 切换清晰度时,显示切换提示
      type_name_show: false,
      key: "",
      type: 3,
      _timer: null, // 显示控制条的定时器
      showNum: false,
      playTimer: null, // 播放定时器
      videoInfo: {}, // 正在播放的视频信息
      getTimeCount: null,
      showPlayBtn: false,
      NotPC: true,
      VHeight:'',
      VWidth: ''
    };
  },
  mounted() {
    if(!IsPC()){
      this.NotPC = true
    } else {
      this.NotPC = false;
    }
    this.VWidth = document.documentElement.clientWidth;
    this.VHeight = document.documentElement.clientHeight;
    this.showNum = this.videoFile.length > 1 ? true : false;
    if (this.videoFile.length == 1) {
      this.url = this.videoFile;
      // if (this.url[0]) {
      //   this.key = this.url[0].replace("http://dudao2.tianwangwatch.cn/", "");
      // }
    } else {
      this.url = this.videoFile[0].hdUrl;
      if (this.url) {
        this.key = this.url.replace("http://dudao2.tianwangwatch.cn/", "");
      }
      for (var i = 0; i < this.videoFile.length; i++) {
        // this.numList.push("第" + (i + 1) + "集");
        this.numList.push("第" + this.videoFile[i].videoBlues + "集");
        // this.numList.push(this.videoFile[i].videoName)
      }
    }
    this.videoInfo = this.videoFile[0];
    this.url = this.videoFile[0].hdUrl
      ? this.videoFile[0].hdUrl
      : this.videoFile[0].fhdUrl;
    this.videoTitle = this.videoFile[0].videoName;
    if (this.videoFile[0].fhdUrl) {
      this.DefinitionList.push("超清");
    }
    if (this.videoFile[0].hdUrl) {
      this.type_index = 1;
      this.DefinitionList.push("高清");
    }
    if (this.videoFile[0].sdUrl) {
      this.DefinitionList.push("标清");
    }
    this.InitVideo();
    window.onresize = () => {
      this.VWidth = document.documentElement.clientWidth;
      this.VHeight = document.documentElement.clientHeight;
      if(this.VWidth>this.VHeight&&!IsPC()){
        this.fullCss = {
          // width: this.Vwidth,
          // height: this.Vheight,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          "z-index": 10000
        };
        this.$root.center.$emit("hiddenTab", true);
      } else if(this.VWidth<this.VHeight&&!IsPC()){
        this.fullCss = {};
        this.vcIsFull = false;
        this.$root.center.$emit("hiddenTab", false);
      }
      // if (width > height && !IsPC()) {
      //   this.Vwidth =
      //     window.innerWidth ||
      //     document.documentElement.clientWidth ||
      //     document.body.clientWidth;
      //   this.Vheight =
      //     window.innerHeight ||
      //     document.documentElement.clientHeight ||
      //     document.body.clientHeight;
      //   this.fullCss = {
      //     // width: this.Vwidth,
      //     // height: this.Vheight,
      //     position: "fixed",
      //     top: 0,
      //     left: 0,
      //     right: 0,
      //     bottom: 0,
      //     "z-index": 10000
      //   };
      //   this.$root.center.$emit("hiddenTab", true);
      // } else if (!IsPC()) {
      //   this.fullCss = {};
      //   this.$root.center.$emit("hiddenTab", false);
      //   // this.vcIsFull = false;
      // }



      
      // if(width>height&&this.vcIsFull&&!IsPC){
      //   console.log('横屏且全屏')
      // } else if(width<height&&!this.vcIsFull&&!IsPC){
      //   console.log('竖屏且不全屏')
      // }
      // if (width > height && !IsPC()) {
      //   if (this.vcIsFull) {
      //     console.log("手机横屏且全屏展示");
      //     // this.Vwidth =
      //     //     window.innerWidth ||
      //     //     document.documentElement.clientWidth ||
      //     //     document.body.clientWidth;
      //     //   this.Vheight =
      //     //     window.innerHeight ||
      //     //     document.documentElement.clientHeight ||
      //     //     document.body.clientHeight;
      //     // this.fullCss = {
      //     //     transform:
      //     //       "rotate(0) translate(0px 0px)",
      //     //     width: this.Vheight + "px",
      //     //     height: this.Vwidth + "px",
      //     //     // "transform-origin": "center center",
      //     //     // "-webkit-transform-origin": "center center",
      //     //     transition: "all 0.1s",
      //     //     position: "fixed",
      //     //     "z-index": 10000,
      //     //     top: 0,
      //     //     right: 0,
      //     //     bottom: 0,
      //     //     left: 0
      //     //   };
      //   } else {
      //     console.log("电脑端展示");
      //   }
      // } else if (width < height && !IsPC()) {
      //   if (this.vcIsFull) {
      //     console.log("手机全屏且没有旋转");
      //     // this.Vwidth =
      //     //     window.innerWidth ||
      //     //     document.documentElement.clientWidth ||
      //     //     document.body.clientWidth;
      //     //   this.Vheight =
      //     //     window.innerHeight ||
      //     //     document.documentElement.clientHeight ||
      //     //     document.body.clientHeight;
      //     //   this.fullCss = {
      //     //     transform:
      //     //       "rotate(90deg) translate(" +
      //     //       (this.Vheight - this.Vwidth) / 2 +
      //     //       "px," +
      //     //       (this.Vheight - this.Vwidth) / 2 +
      //     //       "px)",
      //     //     width: this.Vheight + "px",
      //     //     height: this.Vwidth + "px",
      //     //     "transform-origin": "center center",
      //     //     "-webkit-transform-origin": "center center",
      //     //     transition: "all 0.1s",
      //     //     position: "fixed",
      //     //     "z-index": 2006,
      //     //     top: 0,
      //     //     right: 0,
      //     //     bottom: 0,
      //     //     left: 0
      //     //   };
      //   } else {
      //     console.log("电脑端展示");
      //   }
      // }
    };
  },
  created() {
    this._timer = setTimeout(() => {
      document.querySelector(".controls").style.display = "none";
      if (this.vcIsFull) {
        document.querySelector(".control_top").style.display = "none";
      }
    }, 5000);
  },
  methods: {
    // 判断是安卓还是IOS
    isIos() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return false;
      }
      if (isIOS) {
        //这个是ios操作系统
        return true;
      }
    },
    // 手势快进快退
    vuetouch: function(s, e) {
      // this.name = s.name;
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (this.video.duration) {
        if(width>height){
          if (s.name == "左滑") {
            this.video.currentTime =
            this.video.currentTime - 10 >= 0 ? this.video.currentTime - 10 : 0;
          } else if (s.name == "右滑") {
            this.video.currentTime += 10;
          }
        } else if (width<height){
          if(this.vcIsFull){
            if (s.name == "上滑") {
              this.video.currentTime =
              this.video.currentTime - 10 >= 0 ? this.video.currentTime - 10 : 0;
            } else if (s.name == "下滑") {
              this.video.currentTime += 10;
            }
          } else{
            if (s.name == "左滑") {
              this.video.currentTime =
              this.video.currentTime - 10 >= 0 ? this.video.currentTime - 10 : 0;
            } else if (s.name == "右滑") {
              this.video.currentTime += 10;
            }
          }
        }
      }
    },
    // 初始化视频
    InitVideo() {
      var that = this;
      this.video = document.getElementById("video");
      this.timrBar = document.querySelector(".timrBar");
      this.progress = document.getElementsByClassName("progress")[0]; //进度条容器
      this.warp = document.getElementById("video-warp"); //视频区域距离左边距离
      this.sound = document.getElementsByClassName("video-sound")[0]; //音量容器
      var num = 0;
      that.disabled = true;
      if(!that.isIos()){
        // console.log(that.video.duration)
        console.log("IOS", that.isIos());
        // if(!that.isIOS()&&!IsPC()){
        that.isPlay = true;
        that.getTimeCount = setInterval(() => {
          // console.log(that.video,that.video.duration)
          if (that.video.duration) {
            that.vcTotalTime = that.timer(that.video.duration);
            clearInterval(that.getTimeCount);
            that.getTimeCount = null;
            that.disabled = false;
            this.videoLoading = false;
            that.showPlayBtn = true;
            that.isPlay = false;
            that.play();
          }
          // num++;
          // if (num >= 10000) {
          //   that.disabled = true;
          //   that.showTip = true;
          //   this.videoLoading = false;
          //   clearInterval(that.getTimeCount);
          //   that.getTimeCount = null;
          // }
        }, 10);
      }
      // }
    },
    // 头部返回
    backVideo() {
      this.fullScreen();
    },
    // 显示控制条
    showControl() {
      clearTimeout(this._timer);
      this._timer = null;
      this.isShowControl = true;
      var that = this;
      if (this.isShowControl) {
        document.querySelector(".controls").style.display = "flex";
        if (this.vcIsFull) {
          document.querySelector(".control_top").style.display = "flex";
        }
        that._timer = setTimeout(() => {
          document.querySelector(".controls").style.display = "none";
          if (this.vcIsFull) {
            document.querySelector(".control_top").style.display = "none";
          }
          that.isShowControl = false;
        }, 5000);
      } else {
        document.querySelector(".controls").style.display = "none";
        if (this.vcIsFull) {
          document.querySelector(".control_top").style.display = "none";
        }
      }
    },
    // 选择清晰度
    ShowArticulationType() {
      this.isShowArticulationType = !this.isShowArticulationType;
      this.isShowAnthologyNum = false;
    },
    // 选集
    selectAnthology() {
      this.isShowAnthologyNum = !this.isShowAnthologyNum;
      this.isShowArticulationType = false;
    },
    // 选择集数
    selectNum_active(index) {
      // this.pause();
      this.vcTotalTime = "00:00";
      this.vcCurrentTime = "00:00";
      this.percent = 0;
      this.num_index = this.videoFile[index].videoBlues - 1;
      this.num_index_show = true;
      this.videoInfo = this.videoFile[index];
      this.url = this.videoFile[index].hdUrl;
      this.videoTitle = this.videoFile[index].videoName;
      if (!this.isPlay) {
        this.isPlay = !this.isPlay;
      }
      this.InitVideo();
      // this.play();
    },
    // 播放时的缓冲
    waiting() {
      this.videoLoading = true;
      // this.vcTotalTime = this.timer(this.video.duration);
    },
    // loadstart 开始加载
    loadstart() {
      this.videoLoading = true;
    },
    // loadeddata 加载完
    loadeddata() {
      this.videoLoading = false;
      // this.vcTotalTime = this.timer(this.video.duration);
    },
    // 是否可以播放
    canplay() {
      var that = this;
      that.disabled = false;
      this.videoLoading = false;
      that.vcTotalTime = that.timer(that.video.duration);
      that.playTimer = setInterval(() => {
        // that.isPlay = false;
        that.ontimeupdate();
      }, 1);
      setTimeout(() => {
        that.type_name_show = false;
        that.num_index_show = false;
        var u = navigator.userAgent,
          app = navigator.appVersion;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        var IsIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          //这个是安卓操作系统
          // that.video.play();
          document.getElementById("video").play();
          that.isPlay = true;
          // alert('jinlail anzhuo')
        }
        else if (!isAndroid) {
          //这个是ios操作系统
          that.isPlay = false;
          that.play();
          // alert('IOS')
        }
      }, 1500);
    },
    // 是否播放完
    ended() {
      this.isPlay = true;
      clearInterval(this.playTimer);
      this.playTimer = null;
      var that = this;
      if (this.num_index + 1 < this.videoFile.length) {
        this.num_index += 1;
        this.num_index_show = true;
        setTimeout(() => {
          that.videoInfo = that.videoFile[that.num_index];
          that.videoTitle = that.videoInfo.videoName;
          that.url = that.videoInfo.hdUrl
            ? that.videoInfo.hdUrl
            : that.videoInfo.fhdUrl;
          that.getPlayTime();
          that.InitVideo();
          that.DefinitionList = [];
          if (that.videoInfo.fhdUrl) {
            that.DefinitionList.push("超清");
          }
          if (that.videoInfo.hdUrl) {
            that.type_index = 1;
            that.DefinitionList.push("高清");
          }
          if (that.videoInfo.sdUrl) {
            that.DefinitionList.push("标清");
          }
        }, 2000);
      }
    },
    // 选择清晰度
    selectDefinition(item, index) {
      this.type_index = index;
      var timeCount = this.video.currentTime;
      if (item == "超清") {
        this.type_name = "超清";
        this.type_name_show = true;
        this.url = this.videoInfo.fhdUrl;
        this.video.load();
        this.play();
        this.video.currentTime = timeCount;
      } else if (item == "高清") {
        this.type_name = "高清";
        this.type_name_show = true;
        this.url = this.videoInfo.hdUrl;
        this.video.load();
        this.play();
        this.video.currentTime = timeCount;
      } else if (item == "标清") {
        this.type_name = "标清";
        this.type_name_show = true;
        this.url = this.videoInfo.sdUrl;
        this.video.load();
        this.play();
        this.video.currentTime = timeCount;
      }
    },
    showPopup() {
      console.log("点击了");
      this.isShowAnthologyNum = false;
      this.isShowArticulationType = false;
    },
    // 设置全屏
    fullScreen() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (!IsPC()) {
        if (this.vcIsFull == false) {
          if (width < height) {
            this.Vwidth =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth;
            this.Vheight =
              window.innerHeight ||
              document.documentElement.clientHeight ||
              document.body.clientHeight;
            this.fullCss = {
              transform:
                "rotate(90deg) translate(" +
                (this.Vheight - this.Vwidth) / 2 +
                "px," +
                (this.Vheight - this.Vwidth) / 2 +
                "px)",
              width: this.Vheight + "px",
              height: this.Vwidth + "px",
              "transform-origin": "center center",
              "-webkit-transform-origin": "center center",
              transition: "all 0.1s",
              position: "fixed",
              "z-index": 2006,
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            };
          } else {
            this.Vwidth =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth;
            this.Vheight =
              window.innerHeight ||
              document.documentElement.clientHeight ||
              document.body.clientHeight;
            this.fullCss = {
              width: this.Vwidth + "px",
              height: this.Vheight + "px",
              transition: "all 0.1s",
              position: "fixed",
              "z-index": 2006,
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            };
            document.querySelector(".controls").style.height = "40px";
            document.querySelector(".controls").style.fontSize = "16px";
          }

          // console.log(this.fullCss)
          this.vcIsFull = true;
        } else {
          // this.exitFullscreen(this.video);
          this.vcIsFull = false;
          this.isShowArticulationType = false;
          this.isShowAnthologyNum = false;
          this.fullCss = {};
          document.querySelector(".controls").style.height = "40px";
          document.querySelector(".controls").style.fontSize = "16px";
        }
      } else {
        if (this.vcIsFull == false) {
          console.log("显示全屏");
          this.Vwidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
          this.Vheight =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
          this.fullCss = {
            width: this.Vwidth + "px",
            height: this.Vheight + "px",
            transition: "all 0.1s",
            position: "fixed",
            "z-index": 10000,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          };
          this.vcIsFull = true;
          // this.requestFullscreen(this.video);
        } else {
          console.log("关闭全屏");
          this.vcIsFull = false;
          this.isShowArticulationType = false;
          this.isShowAnthologyNum = false;
          this.fullCss = {};
          // this.exitFullscreen(this.video);
        }
      }
    },
    // 播放
    play() {
      var that = this;
      if (
        (that.video.paused || that.video.ended) &&
        this.vcTotalTime != "00:00"
      ) {
        that.video.play();
        if (!that.playTimer) {
          that.playTimer = setInterval(() => {
            // that.isPlay = false;
            that.ontimeupdate();
          }, 1);
        }
        that.isPlay = false;
      }
    },
    // 暂停
    pause() {
      if (!this.video.paused || !this.video.ended) {
        this.video.pause();
        clearInterval(this.playTimer);
        this.playTimer = null;
        this.isPlay = true;
      }
    },
    // 获取时长
    getPlayTime() {
      // console.log(this.video.duration, this.video.currentTime);
      if (this.video.duration && this.video.duration != undefined) {
        this.vcTotalTime = this.timer(this.video.duration);
      }
      if (this.video.currentTime && this.video.currentTime != undefined) {
        this.vcCurrentTime = this.timer(this.video.currentTime);
      }
    },
    //时间格式化
    timer(seconds) {
      var minute = Math.floor(seconds / 60);
      if (minute < 10) {
        minute = "0" + minute;
      }

      var second = Math.floor(seconds % 60);
      if (second < 10) {
        second = "0" + second;
      }
      return minute + ":" + second;
    },
    // 进度条跟随
    ontimeupdate() {
      var currentTime = this.video.currentTime;
      var duration = this.video.duration;
      this.percent = (currentTime / duration) * 100;
      this.vcCurrentTime = currentTime ? this.timer(currentTime) : "00:00";
    },
    // 进度条拖拽
    onChange(value) {
      // this.$toast('当前值：' + value);
      this.video.currentTime = (this.video.duration * value) / 100;
      this.vcCurrentTime = this.timer((this.video.duration * value) / 100);
    },
    //进度条获取坐标调用 拖拽实现方法
    // enableProgressDrag(e) {
    //   if (this.vcIsFull && navigator.platform.indexOf("Win") == -1) {
    //     // this.progressDrag = false;
    //     // this.progress.onmousedown = function(e) {
    //     //     this.progressDrag = true;
    //     this.updateprogress(e.pageY - this.warp.offsetTop);
    //     // }
    //     // document.onmouseup = function(e) {
    //     //     if(this.progressDrag) {
    //     //         this.progressDrag = false;
    //     //         this.updateprogress(e.pageX - this.warp.offsetLeft);
    //     //     }

    //     // }
    //     // this.progress.onmousemove = function(e) {
    //     //     if(this.progressDrag) {
    //     //         this.updateprogress(e.pageX - this.warp.offsetLeft);
    //     //     }
    //     // }
    //   } else {
    //     console.log(e.pageX, "撒大声地所多", this.warp.offsetLeft);
    //     // this.progressDrag = false;
    //     // this.progress.onmousedown = function(e) {
    //     //     this.progressDrag = true;
    //     this.updateprogress(e.pageX - this.warp.offsetLeft);
    //     // }
    //     // document.onmouseup = function(e) {
    //     //     if(this.progressDrag) {
    //     //         this.progressDrag = false;
    //     //         this.updateprogress(e.pageX - this.warp.offsetLeft);
    //     //     }

    //     // }
    //     // this.progress.onmousemove = function(e) {
    //     //     if(this.progressDrag) {
    //     //         this.updateprogress(e.pageX - this.warp.offsetLeft);
    //     //     }
    //     // }
    //   }
    // },
    // //进度条可拖拽实现
    // updateprogress(x) {
    //   this.percent =
    //     (100 * (x - this.progress.offsetLeft)) / this.progress.offsetWidth;
    //   if (this.percent > 100) {
    //     this.percent = 100;
    //     this.isPlay = true;
    //   }
    //   if (this.percent < 0) {
    //     this.percent = 0;
    //   }
    //   this.video.currentTime = (this.video.duration * this.percent) / 100;
    // },
    // 是否静音
    // muteAction() {
    //   this.isSound = !this.isSound;
    // },
    // // 音量获取坐标调用 拖拽实现方法
    // enableSoundDrag() {
    //   // var soundDrag = false;
    //   // this.sound.onmousedown = function(e) {
    //   // soundDrag = true;
    //   this.updatesound(e.pageX - this.warp.offsetLeft);
    //   // }
    //   // this.sound.onmouseup = function(e) {
    //   //     if(soundDrag) {
    //   //         soundDrag = false;
    //   //         updatesound(e.pageX - this.warp.offsetLeft);
    //   //     }

    //   // }
    //   // this.sound.onmousemove = function(e) {
    //   //     if(soundDrag) {
    //   //         updatesound(e.pageX - this.warp.offsetLeft);
    //   //     }
    //   // }
    // },
    // //音量可拖拽实现
    // updatesound(x, n) {
    //   sounding();
    //   if (n) {
    //     soundPercent = n;
    //   } else {
    //     soundPercent =
    //       (100 * (x - this.sound.offsetLeft)) / this.sound.offsetWidth;
    //   }
    //   if (soundPercent > 100) {
    //     persoundPercentcent = 100;
    //   }
    //   if (soundPercent < 0) {
    //     soundPercent = 0;
    //   }
    //   // this.soundBar.style.width = soundPercent + "%";
    //   this.video.volume = soundPercent / 100;
    // },
    // sounding() {
    //   if (v.video.volume == 0) {
    //     sound.style.display = "none";
    //     muteSound.style.display = "inline-block";
    //   } else {
    //     sound.style.display = "inline-block";
    //     muteSound.style.display = "none";
    //   }
    // },
    //切换静音
    // sound.onclick=function(){
    //     showHide(sound,muteSound);
    //     v.video.volume =0;
    //     v.soundBar.style.width=0;
    // },
    // //去除静音 音量回到之前选定区域
    // muteSound.onclick=function(){
    //     showHide(muteSound,sound);
    //     v.soundBar.style.width = soundPercent + "%";
    //     v.video.volume = soundPercent / 100;
    // },
    //显示与隐藏
    showHide(a, b) {
      a.style.display = "none";
      b.style.display = "inline-block";
    },
    // 全屏
    // ele:全屏的对象
    requestFullscreen(ele) {
      // 全屏兼容代码
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },

    // 取消全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
    }
    // //进度条获取坐标调用 拖拽实现方法
    // enableProgressDrag = function(e) {
    //   var progressDrag = false;
    //   this.video.progress.onmousedown = function(e) {
    //       progressDrag = true;
    //       updateprogress(e.pageX - v.warp.offsetLeft);
    //   }
    //   document.onmouseup = function(e) {
    //       if(progressDrag) {
    //           progressDrag = false;
    //           updateprogress(e.pageX - this.video.warp.offsetLeft);
    //       }

    //   }
    //   this.video.progress.onmousemove = function(e) {
    //       if(progressDrag) {
    //           updateprogress(e.pageX - this.video.warp.offsetLeft);
    //       }
    //   }
    // },
    // // 音量获取坐标调用 拖拽实现方法
    // enableSoundDrag(){
    //   var soundDrag = false;
    //   this.video.sound.onmousedown = function(e) {
    //       soundDrag = true;
    //       updatesound(e.pageX - this.video.warp.offsetLeft);
    //   }
    //   this.video.sound.onmouseup = function(e) {
    //       if(soundDrag) {
    //           soundDrag = false;
    //           updatesound(e.pageX - this.video.warp.offsetLeft);
    //       }

    //   }
    //   this.video.sound.onmousemove = function(e) {
    //       if(soundDrag) {
    //           updatesound(e.pageX - this.video.warp.offsetLeft);
    //       }
    //   }
    // },
    //         v.video.onloadedmetadata = function() {
    //             //播放
    //             v.play.onclick = function() {
    //                 if(v.video.paused || v.video.ended) {
    //                     v.video.play();
    //                     this.style.display = "none";
    //                     v.pause.style.display = "inline-block";
    //                 }
    //             }
    //             //暂停
    //             v.pause.onclick = function() {
    //                 if(!v.video.paused || !v.video.ended) {
    //                     v.video.pause();
    //                     v.pause.style.display = "none";
    //                     v.play.style.display = "inline-block";
    //                 }
    //             }
    //             //获取时长
    //             v.duration.innerHTML = timer(v.video.duration);
    //             v.currentTime.innerHTML = timer(v.video.currentTime);
    //             //进度条跟随
    //             v.video.ontimeupdate = function() {
    //                 var currentTime = v.video.currentTime;
    //                 var duration = v.video.duration;
    //                 var percent = currentTime / duration * 100;
    //                 v.timrBar.style.width = percent + "%";
    //                 v.currentTime.innerHTML = timer(v.video.currentTime);
    //             }
    //             //进度条获取坐标调用 拖拽实现方法
    //             var enableProgressDrag = function(e) {
    //                 var progressDrag = false;
    //                 v.progress.onmousedown = function(e) {
    //                     progressDrag = true;
    //                     updateprogress(e.pageX - v.warp.offsetLeft);
    //                 }
    //                 document.onmouseup = function(e) {
    //                     if(progressDrag) {
    //                         progressDrag = false;
    //                         updateprogress(e.pageX - v.warp.offsetLeft);
    //                     }

    //                 }
    //                 v.progress.onmousemove = function(e) {
    //                     if(progressDrag) {
    //                         updateprogress(e.pageX - v.warp.offsetLeft);
    //                     }
    //                 }
    //             };

    //             enableProgressDrag();
    //             //播放速率
    //             // v.playSpeed.onclick = function() {
    //             //     v.video.playbackRate = 3;
    //             // }

    //             //音量获取坐标调用 拖拽实现方法
    //             var enableSoundDrag = function(e) {
    //                 var soundDrag = false;
    //                 v.sound.onmousedown = function(e) {
    //                     soundDrag = true;
    //                     updatesound(e.pageX - v.warp.offsetLeft);
    //                 }
    //                 v.sound.onmouseup = function(e) {
    //                     if(soundDrag) {
    //                         soundDrag = false;
    //                         updatesound(e.pageX - v.warp.offsetLeft);
    //                     }

    //                 }
    //                 v.sound.onmousemove = function(e) {
    //                     if(soundDrag) {
    //                         updatesound(e.pageX - v.warp.offsetLeft);
    //                     }
    //                 }
    //             };
    //             enableSoundDrag();
    //             updatesound(null, 35); //初始化音量
    //             /*全屏*/
    //             var isScreen=false;
    //             v.fullScreen.addEventListener("click",function(){
    //                 if(isScreen==false){

    //                     requestFullscreen(v.video);
    //                     isScreen=true;
    //                 }else{
    //                     exitFullscreen(v.video);
    //                     isScreen=false;
    //                 }
    //             })
    //         }
    //         //进度条可拖拽实现
    //         updateprogress(x) {
    //             var percent = 100 * (x - v.progress.offsetLeft) / v.progress.offsetWidth;
    //             if(percent > 100) {
    //                 percent = 100;
    //             }
    //             if(percent < 0) {
    //                 percent = 0;
    //             }
    //             v.timrBar.style.width = percent + "%";
    //             v.video.currentTime = v.video.duration * percent / 100;

    //         }
    //         //音量可拖拽实现
    //         updatesound(x, n) {
    //             sounding();
    //             if(n) {
    //                 soundPercent = n;
    //             } else {
    //                 soundPercent = 100 * (x - v.sound.offsetLeft) / v.sound.offsetWidth;
    //             }
    //             if(soundPercent > 100) {
    //                 persoundPercentcent = 100;
    //             }
    //             if(soundPercent < 0) {
    //                 soundPercent = 0;
    //             }
    //             v.soundBar.style.width = soundPercent + "%";
    //             v.video.volume = soundPercent / 100;
    //         }
    //         //时间格式化
    //         timer(seconds) {
    //             var minute = Math.floor(seconds / 60);
    //             if(minute < 10) {
    //                 minute = "0" + minute;
    //             }

    //             var second = Math.floor(seconds % 60);
    //             if(second < 10) {
    //                 second = "0" + second;
    //             }
    //             return minute + ":" + second;
    //         }
    //         //是否静音
    //         var sound = document.querySelector("#sound");
    //         var muteSound = document.querySelector("#muteSound");
    //         sounding() {
    //             if(v.video.volume == 0 ) {
    //                 sound.style.display = "none";
    //                 muteSound.style.display = "inline-block";
    //             } else {
    //                 sound.style.display = "inline-block";
    //                 muteSound.style.display = "none";
    //             }
    //         }
    //         //切换静音
    //         sound.onclick=function(){
    //             showHide(sound,muteSound);
    //             v.video.volume =0;
    //             v.soundBar.style.width=0;
    //         }
    //         //去除静音 音量回到之前选定区域
    //         muteSound.onclick=function(){
    //             showHide(muteSound,sound);
    //             v.soundBar.style.width = soundPercent + "%";
    //             v.video.volume = soundPercent / 100;
    //         }
    //         //显示与隐藏
    //         showHide(a,b){
    //             a.style.display = "none";
    //             b.style.display = "inline-block";
    //         }

    //         /*全屏*/
    //         // 全屏
    //         // ele:全屏的对象
    //         requestFullscreen(ele) {
    //             // 全屏兼容代码
    //             if (ele.requestFullscreen) {
    //                 ele.requestFullscreen();
    //             } else if (ele.webkitRequestFullscreen) {
    //                 ele.webkitRequestFullscreen();
    //             } else if (ele.mozRequestFullScreen) {
    //                 ele.mozRequestFullScreen();
    //             } else if (ele.msRequestFullscreen) {
    //                 ele.msRequestFullscreen();
    //             }
    //         }

    //         // 取消全屏
    //         exitFullscreen() {
    //             if (document.exitFullscreen) {
    //                 document.exitFullscreen();
    //             } else if (document.webkitExitFullscreen) {
    //                 document.webkitExitFullscreen();
    //             } else if (document.msExitFullscreen) {
    //                 document.msExitFullscreen();
    //             } else if (document.mozCancelFullScreen) {
    //                 document.mozCancelFullScreen();
    //             }
    //         }

    // 开始按
    // gotouchstart(e){
    //   console.log(e)
    //   let that = this;
    //   clearTimeout(that.timeOutEvent);//清除定时器
    //   that.timeOutEvent = 0;
    //   that.timeOutEvent = setTimeout(function(){
    //       //执行长按要执行的内容，
    //   },600);//这里设置定时
    //   console.log('gotouchstart',e.pageX)
    // },
    // // 移动
    // gotouchmove(e){
    //   console.log(e)
    //   var that = this;
    //   clearTimeout(that.timeOutEvent);
    //   if(that.timeOutEvent!=0){
    //     //这里写要执行的内容（尤如onclick事件）
    //  }
    //   console.log('gotouchmove',e.pageX)
    // },
    // // 松开
    // gotouchend(e){
    //   console.log(e)
    //   var that = this;
    //   clearTimeout(that.timeOutEvent);//清除定时器
    //  that.timeOutEvent = 0;
    //   console.log('gotouchend',e.pageX)
    // },
  },
  beforeDestroy() {
    clearInterval(this._timer);
    this._timer = null;
    clearInterval(this.timerListener);
    this.timerListener = null;
    clearInterval(this.playTimer);
    this.playTimer = null;
    this.isPlay = true;
    this.$root.center.$off("hiddenTab");
    clearInterval(this.getTimeCount);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.video-warp {
  width: 100%;
  /* height: 216px; */
  font-size: 0;
  position: relative;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  background-color: #000;
}
.video-warp .control_top {
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  height: 30px;
  padding: 0 15px;
}
.video-warp .control_top .backVideoIcon {
  width: 10px;
  height: 15px;
  vertical-align: middle;
  margin-right: 5px;
}
.controls {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0px;
  color: #fff;
  font-size: 14px;
  transition: all 0.5s;
  z-index: 19999;
}
.controls .progress {
  flex: 1;
  margin-right: 15px;
}
.controls .timrBar {
  height: 5px;
  width: 0;
  opacity: 0.6;
  background: #5576ab;
  border-radius: 4px;
}
.controls .video-sound {
  width: 10%;
  height: 10px;
  border-radius: 5px;
  border: 1px solid #000;
}
.controls .articulate {
  position: relative;
  line-height: 40px;
  margin-right: 15px;
  text-align: center;
  z-index: 100000000;
  /* color: #fff; */
}
.articulationType {
  width: 159px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 40px;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  overflow: auto;
  padding-top: 20px;
  /* padding-bottom: 50px; */
  background-color: rgba(0, 0, 0, 0.4);
}
.articulationType > div {
  opacity: 0.8;
  border: 1px solid #ffffff;
  border-radius: 4px;
  width: 124px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  margin: 10px;
}
.selectType {
  border: 1px solid #f40 !important;
  color: #f40 !important;
  transition: all 0.5s;
}
.controls .articulationType > div {
  border-bottom: 0.5px solid #eeeeee;
}
.controls .articulationType > div:last-child {
  border: 0px;
}
.controls .articulationType::after {
  content: "";
  display: block;
  width: 0px;
  height: 0px;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  border-top: 10px solid rgba(0, 0, 0, 0.8);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.controls .Anthology {
  position: relative;
  line-height: 40px;
  text-align: center;
  margin-right: 15px;
  /* color: #fff; */
  z-index: 1000000000;
}
.AnthologyNum {
  width: 159px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 40px;
  color: #fff;
  font-weight: 500;
  box-sizing: border-box;
  /* display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center; */
  overflow: hidden;

  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.4);
}
.AnthologyNum > div > div > div {
  opacity: 0.8;
  border: 1px solid #ffffff;
  border-radius: 4px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  margin: 10px;
}
.selectNum {
  border: 1px solid #f40 !important;
  color: #f40 !important;
  transition: all 0.5s;
}
/* .AnthologyNum::after{
    content: '';
    display: block;
    width: 0px;
    height: 0px;
    border-right:10px solid transparent;
    border-left:10px solid transparent;
    border-top:10px solid rgba(0, 0, 0, 0.8);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  } */
#play,
#pause {
  width: 9px;
  height: 13px;
  margin-right: 5px;
}
#fullScreen {
  width: 14px;
  position: relative;
  z-index: 100000;
}
.video-timer {
  /* font-size: 11px; */
  color: #fff;
  margin-right: 15px;
}
.van-slider__button {
  width: 10px !important;
  height: 10px !important;
}
</style>
<style>
._controls {
  background-color: rgba(0, 0, 0, 0.5);
  width: 40px;
  height: 100%;
  padding: 10px 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  color: #fff;
  font-size: 14px;
  transition: all 0.5s;
  z-index: 19999;
}
._controls span{
  display: inline-block;
  height: auto;
  transform: rotate(90deg);
  transform-origin: center center;
}
._controls .play-icon{
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
  transform-origin: center center;
}
._controls ._video-timer{
  display: flex;
  min-height: 80px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
._controls ._video-timer ._currentTime{
  margin-bottom: 3px;
}
._controls ._video-timer span:nth-child(2){
  height: 16px;
  width: 3px;
}
._controls ._progress {
  width: 10px;
  flex: 1;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
._controls ._progress .van-slider{
  width: 2px;
  height: 100%;
}
._controls ._articulate{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
._controls ._articulate span{
  display: inline-block;
  width: 60px;
  height: 40px;
  display: flex;
  align-items: center;
}
._controls ._Anthology {
  width: 40px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/video.vue